import { Conduit } from '@campingvision/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}ski/rental/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {

  /**
   * @param route
   * @returns {AxiosPromise}
   */
  getSeasonsWithRelations() {
    return conduit.get('seasons/with-relations');
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getSeasonById(seasonId) {
    return conduit.get(`seasons/${seasonId}`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getSeasonWithRelationsBySeasonId(seasonId) {
    return conduit.get(`seasons/${seasonId}/with-relations`);
  },

  /**
   * @param skiRentalSeason
   * @returns {AxiosPromise}
   */
  createSeason(skiRentalSeason) {
    return conduit.post('seasons/add', {
      skiRentalSeason,
    });
  },

  /**
   * @param skiRentalSeason
   * @returns {AxiosPromise}
   */
  saveSeason(skiRentalSeason) {
    return conduit.put(`seasons/${skiRentalSeason.id}/update`, {
      skiRentalSeason,
    });
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getPeriodDatesBySeasonId(seasonId) {
    return conduit.get(`seasons/${seasonId}/periods`);
  },

  /**
   * @param seasonId
   * @param skiRentalPeriod
   * @returns {AxiosPromise}
   */
  createPeriodDate(seasonId, skiRentalPeriod) {
    return conduit.post(`seasons/${seasonId}/periods/add`, {
      skiRentalPeriod,
    });
  },

  /**
   * @param seasonId
   * @param periodId
   * @returns {AxiosPromise}
   */
  deletePeriodDate(seasonId, periodId) {
    return conduit.delete(`seasons/${seasonId}/periods/${periodId}/delete`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getPersonCategoriesById(seasonId) {
    return conduit.get(`person-categories/season/${seasonId}`);
  },

  /**
   * @param skiRentalPersonCategory
   * @returns {AxiosPromise}
   */
  createPersonCategory(skiRentalPersonCategory) {
    return conduit.post('person-categories/add', {
      skiRentalPersonCategory,
    });
  },

  /**
   * @param skiRentalPersonCategory
   * @returns {AxiosPromise}
   */
  savePersonCategory(skiRentalPersonCategory) {
    return conduit.put(`person-categories/${skiRentalPersonCategory.id}/update`, {
      skiRentalPersonCategory,
    });
  },

  /**
   * @param personCategoryId
   * @returns {AxiosPromise}
   */
  deletePersonCategory(personCategoryId) {
    return conduit.delete(`person-categories/${personCategoryId}/delete`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getDiscountsBySeasonId(seasonId) {
    return conduit.get(`discounts/season/${seasonId}/relations`);
  },

  /**
   * @param skiRentalDiscount
   * @returns {AxiosPromise}
   */
  createDiscount(skiRentalDiscount) {
    return conduit.post('discounts/add', {
      skiRentalDiscount,
    });
  },

  /**
   * @param skiRentalDiscount
   * @returns {AxiosPromise}
   */
  saveDiscount(skiRentalDiscount) {
    return conduit.put(`discounts/${skiRentalDiscount.id}/update`, {
      skiRentalDiscount,
    });
  },

  /**
   * @param discountId
   * @returns {AxiosPromise}
   */
  deleteDiscount(discountId) {
    return conduit.delete(`discounts/${discountId}/delete`);
  },

  /**
   * @param discountId
   * @param personCategoryId
   * @returns {AxiosPromise}
   */
  savePersonCategoryOnDiscount(discountId, personCategoryId) {
    return conduit.post(
      `discounts/${discountId}/person-category/${personCategoryId}/add`,
      {},
    );
  },

  /**
   * @param discountId
   * @param personCategoryId
   * @returns {AxiosPromise}
   */
  deletePersonCategoryOnDiscount(discountId, personCategoryId) {
    return conduit.delete(`discounts/${discountId}/person-category/${personCategoryId}/delete`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getAreasBySeasonId(seasonId) {
    return conduit.get(`seasons/${seasonId}/areas`);
  },

  /**
   * @param seasonId
   * @param skiAreaId
   * @returns {AxiosPromise}
   */
  saveAreaOnSeason(seasonId, skiAreaId) {
    return conduit.post(
      `seasons/${seasonId}/areas/${skiAreaId}/add`,
      {},
    );
  },

  /**
   * @param seasonId
   * @param skiAreaId
   * @returns {AxiosPromise}
   */
  deleteAreaOnSeason(seasonId, skiAreaId) {
    return conduit.delete(`seasons/${seasonId}/areas/${skiAreaId}/delete`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getSalesTypes() {
    return conduit.get('sales-types');
  },

  /**
   * @returns {AxiosPromise}
   */
  getSkiRentalPackages() {
    return conduit.get('packages');
  },

  /**
   * @returns {AxiosPromise}
   */
  getSkiRentalSkiTypes() {
    return conduit.get('ski-types');
  },

  /**
   * @returns {AxiosPromise}
   */
  getSkiRentalLevels() {
    return conduit.get('levels');
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getPossiblePriceCombinationsBySeasonId(seasonId) {
    return conduit.get(`seasons/${seasonId}/prices-with-days/possible-combinations`);
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getPricesWithDaysBySeasonId(seasonId) {
    return conduit.get(`seasons/${seasonId}/prices-with-days`);
  },

  /**
   * @param seasonId
   * @param skiRentalSeasonPriceWithDays
   * @returns {AxiosPromise}
   */
  addPriceWithDays(seasonId, skiRentalSeasonPriceWithDays) {
    return conduit.post(`seasons/${seasonId}/prices-with-days/add`, {
      skiRentalSeasonPriceWithDays,
    });
  },

  /**
   * @param seasonId
   * @param skiRentalSeasonPriceWithDays
   * @returns {AxiosPromise}
   */
  updatePriceWithDays(seasonId, skiRentalSeasonPriceWithDays) {
    const priceId = skiRentalSeasonPriceWithDays.id;
    return conduit.put(`seasons/${seasonId}/prices-with-days/${priceId}/update`, {
      skiRentalSeasonPriceWithDays,
    });
  },

  /**
   * @param seasonId
   * @param priceId
   * @returns {AxiosPromise}
   */
  deletePrice(seasonId, priceId) {
    return conduit.delete(`seasons/${seasonId}/prices-with-days/${priceId}/delete`);
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/ski-rental-service.js